import { trpc } from '@/lib/trpc';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

const useDeleteWish = () => {
	const { t } = useTranslation();
	const utils = trpc.useUtils();

	const { id_list } = useParams();

	const { mutate, isPending, error } = trpc.wish.delete.useMutation({
		onMutate: async ({ id_wish }) => {
			const successToast = toast.success(
				t('wish.form.delete.notification')
			);

			await utils.wish.get.cancel();

			const previousWishes = utils.wish.get.getData({
				id_list: parseInt(id_list as string),
			}) || {
				status: 200,
				wishes: [],
			};

			const optimisticWishes = previousWishes.wishes.filter(
				(wish) => wish.id !== id_wish
			);

			utils.wish.get.setData(
				{ id_list: parseInt(id_list as string) },
				{ status: 200, wishes: optimisticWishes }
			);

			return {
				previousWishes,
				successToast,
				fk_list: parseInt(id_list as string),
			};
		},
		onError(_, __, context) {
			if (!context?.previousWishes) return;
			utils.wish.get.setData(
				{ id_list: context.fk_list },
				{ status: 200, wishes: context?.previousWishes.wishes }
			);
			toast.dismiss(context.successToast);
			toast.error(t('error.generic'));
		},
	});

	return {
		deleteWish: mutate,
		deleteLoading: isPending,
		deleteError: error,
	};
};

export default useDeleteWish;
